import "./ServicesPage.css";

const TIERS = [
  {
    n: "01",
    title: "Consulting & Advisory",
    desc: "AI strategy, use-case identification, proof-of-concept design, and governance. We help you decide where AI moves the needle — and where it doesn't.",
    bullets: ["AI strategy", "Use-case identification", "Proof-of-concept", "Governance & ethics"],
  },
  {
    n: "02",
    title: "AI/ML Platforms",
    desc: "Production-grade pipelines for data science, knowledge engineering, generative AI, and predictive analytics. Built on AWS, scaled to your needs.",
    bullets: ["Data science pipelines", "Knowledge engineering & GenAI", "Predictive analytics SaaS"],
  },
  {
    n: "03",
    title: "Bespoke Software",
    desc: "Custom ML/AI solutions for problems off-the-shelf can't solve — like BOM correction, cardiac event prediction, and lab-process automation.",
    bullets: ["Custom ML models", "Integration with EHR/LIMS", "Domain-specific tooling"],
  },
  {
    n: "04",
    title: "Training & Enablement",
    desc: "AI literacy workshops, leadership briefings, and hands-on engineering bootcamps that build durable capability inside your team.",
    bullets: ["Executive briefings", "Engineer bootcamps", "AI literacy programs"],
  },
];

const PRODUCTS = [
  "Advanced Analytics", "AI Readiness Assessment", "BI & Visualization",
  "Clinical Trial Optimization", "Computational Pathology", "Data Quality & Lineage",
  "Generative AI for Documentation", "Knowledge Graph Builder", "Lab Data Pipelines",
  "Predictive Maintenance for Lab Equipment", "Real-World Evidence Analytics",
  "Regulatory Submission Assistant", "Workflow Automation",
];

export function ServicesPage() {
  return (
    <>
      <section className="section container">
        <header className="page-hero">
          <p className="eyebrow">Services & Products</p>
          <h1>A hybrid model — consulting, platform, custom build.</h1>
          <p className="lede">
            Most AI work in life sciences fails because it ignores the operational reality of regulated industries. Our four-tier model meets you where you are.
          </p>
        </header>
      </section>

      <section className="section--tight container">
        <div className="tiers">
          {TIERS.map((t) => (
            <article key={t.n} className="tier card">
              <div className="tier__num">{t.n}</div>
              <div>
                <h2 className="tier__title">{t.title}</h2>
                <p className="tier__desc">{t.desc}</p>
                <ul className="tier__bullets">
                  {t.bullets.map((b) => <li key={b}>{b}</li>)}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="section container">
        <header className="section-head">
          <p className="eyebrow">Specific offerings</p>
          <h2>Thirteen places we move fast.</h2>
          <p className="lede">
            Each of these starts with a short discovery engagement so you only pay for what fits your situation.
          </p>
        </header>
        <div className="grid grid--cols-3">
          {PRODUCTS.map((p) => (
            <article key={p} className="card card--interactive product-card">
              <h3>{p}</h3>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
